import Vue from 'vue'
import Vuex from 'vuex'
import * as User from "../models/user";

// Import different modules
import account from './modules/account/store'
import status from './modules/status/store'
import event from './modules/event/store'

import createPersistedState from 'vuex-persistedstate'

Vue.use(Vuex)

export default new Vuex.Store({
    plugins: [createPersistedState()],

    modules: {
        // All modules
        account,
        status,
        event,
    }
});


// WEBPACK FOOTER //
// ./src/vuex/store.ts